The ID of the SEEK job ad, if known.
